// services/api/studentService.js
import API from '../api/api';

export const semesterService = {
  getSemesters: async () => {
    const response = await API.get('/get_semesters');
    return response.data.data || [];
  },
  createSemester: async (payload) => {
    const response = await API.post('/create_semester', payload);
    return response.data;
  },
  
  updateSemester: async (payload) => {
    const response = await API.post('/update_semester', payload);
    return response.data;
  },
  deleteSemester: async (id) => {
    const response = await API.post('/delete_semester', { id });
    return response.data;
  },
};


